<template lang="html">
  <div class="enterprise" >
    <div class="header">
      <ShareHeader :openTarget="'company/collect?id=' + cid" />
    </div>

    <div class="cover">
      <img :src="embodyData.avatar" alt="">
    </div>

    <div class="content" @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend">
      <div class="embodyInfo">
        <div class="enterpriseCover">
          <img :src="embodyData.avatar" alt="" >
          <WxOpenTag ref="wxopentag" :extinfo="'company/collect?id=' + cid"/>
        </div>
        
        <p class="enterpriseName">{{embodyData.username}}</p>
        <p class="enterpriseIntroduction">{{embodyData.official_title}}</p>
      </div>

      <div class="synopsisCon">
        <div class="synopsisTitle">
          <div class="synopsisH1">
            <p class="signIcon"></p>
            <p>企业简介</p>
          </div>
          <p class="stockCode" v-show="embodyData.stock_code">股票代码 {{embodyData.stock_code}}</p>
        </div>

        <div class="describe" v-html="embodyData.enterprise_desc"></div>
      </div>
    </div>
    
    <div :class="isShow ? 'welfareShow' : 'welfareHidden'">
      <img src="../../assets/image/icon/attestation.png" alt="" class="welfareImg">
      <WxOpenTag ref="wxopentag" :extinfo="'company/collect?id=' + cid"/>
    </div>
    
    <div class="footer">
      <div class="correctBtn">
        <img src="../../assets/image/icon/correct.png" alt="">
        <span>纠错</span>
        <WxOpenTag ref="wxopentag" :extinfo="'company/collect?id=' + cid"/>
      </div>
      <p class="source">收录企业 | 来源网络公开数据整理</p>
    </div>
  </div>
</template>

<script>
  import ShareHeader from '@/components/HeadModule'
  import WxOpenTag from '@/components/WxOpenTag'

  export default {
    data() {
      return {
        cid: this.$route.query.id || '',
        embodyData: {},
        isShow: true,
      }
    },

    components: {
      ShareHeader,
      WxOpenTag,
    },

    mounted() {
      this.info();
    },

    methods: {
      info() {
        this.getEnterpriseInfo()
      },

      getEnterpriseInfo() {
        this.$http({
          url: '/eleom/getEnterpriseInfo',
          method: 'get',
          params: {
            company_id: this.cid,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.embodyData = res.data;
          }
        })
      },
      
      touchstart(){
        this.isShow = false;
      },
      
      touchmove(){
        this.isShow = false;
      },
      
      touchend(){
        this.isShow = true;
      },
    }
  }
</script>

<style lang="css" scoped>
  .enterprise {
    box-sizing: border-box;
    height: 100%;
    padding-top: 5.6rem;
    position: relative;
  }

  .header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 99;
  }

  .cover {
    box-sizing: border-box;
    width: 100%;
    height: 14rem;
    overflow: hidden;
  }

  .cover img {
    width: 100%;
    height: 14rem;
    object-fit: cover;
    filter: blur(1rem);
  }

  .content {
    position: relative;
    box-sizing: border-box;
    background-color: #FFFFFF;
    margin-top: -4rem;
    padding: 0 1.5rem;
    padding-bottom: 6rem;
    border-radius: 1rem 1rem 0 0;
    z-index: 10;
  }

  .embodyInfo {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  
  .enterpriseCover {
    position: relative;
    width: 6.4rem;
    height: 6.4rem;
    margin: 0 auto;
    margin-top: -3.9rem;
    border-radius: 50%;
    border: .2rem solid #FFFFFF;
  }

  .enterpriseCover img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  .enterpriseName {
    font-size: 1.7rem;
    font-weight: bold;
    margin-top: .75rem;
  }

  .enterpriseIntroduction {
    box-sizing: border-box;
    font-size: 1.3rem;
    color: #999999;
    margin-top: .2rem;
    padding: 0 2.5rem;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .synopsisCon {}

  .synopsisTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.75rem;
  }

  .synopsisH1 {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    color: #555555;
  }

  .signIcon {
    width: .3rem;
    height: 1.5rem;
    background-color: #49A7F8;
    margin-right: .6rem;
  }

  .stockCode {
    font-size: 1.1rem;
    color: #9FA7B8;
  }

  .describe {
    box-sizing: border-box;
    margin-top: 1.1rem;
  }

  .describe>>>img {
    width: 100%;
    border-radius: 1rem;
    margin: 1rem 0;
  }

  .welfareShow {
    width: 25.85rem;
    height: 5.45rem;
    position: fixed;
    right: 0;
    bottom: 8.8rem;
    z-index: 100;
    animation:hidden .5s;
  }
  
  .welfareHidden {
    width: 25.85rem;
    height: 5.45rem;
    position: fixed;
    right: -23.5rem;
    bottom: 8.8rem;
    z-index: 100;
    animation:show .5s;
  }
  
  .welfareImg {
    width: 100%;
    height: 100%;
  }

  .footer {
    background-color: #FFFFFF;
    width: 100%;
    height: 5.2rem;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .correctBtn {
    position: relative;
    width: 6.4rem;
    height: 2.3rem;
    background-color: #E5F0F9;
    color: #749DC6;
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.15rem;
  }

  .correctBtn img {
    height: 1.5rem;
    margin-right: .4rem;
  }

  .source {
    font-size: 1.2rem;
    color: #999999;
    margin-left: 1.25rem;
  }

  @media (min-width: 751px) {
    .welfare {
      left: 50%;
      margin-left: -142px;
    }

    .footer {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }
  
  @keyframes show {
    0% {
      right: 0;
    }
    
    100% {
      right: -20.5rem;
    }
  }
  
  @keyframes hidden {
    0% {
      right: -20.5rem;
    }
    
    100% {
      right: 0;
    }
  }
</style>
